import { render, staticRenderFns } from "./chooseBank.vue?vue&type=template&id=54057bf6&scoped=true"
import script from "./chooseBank.vue?vue&type=script&lang=js"
export * from "./chooseBank.vue?vue&type=script&lang=js"
import style0 from "./chooseBank.vue?vue&type=style&index=0&id=54057bf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54057bf6",
  null
  
)

export default component.exports